import { gql } from '@apollo/client';

const SAVE_BOOKING = gql`
  mutation SaveBooking($input: saveBookingInput) {
    saveBooking(input: $input) {
      success
      data {
        _id
      }
      message
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation UpdatingBooking($input: updateBookingInput) {
    UpdatingBooking(input: $input) {
      success
      data
      message
    }
  }
`;

export const UPDATE_CONSOLE_BOOKING = gql`
  mutation connectCreateBooking($input: JSON) {
    connectCreateBooking(input: $input)
  }
`;

export const BULK_BUYER_BOOKING = gql`
  mutation BulkCompleteBooking($input: updateBookingInput) {
    BulkCompleteBooking(input: $input) {
      success
      data
      message
    }
  }
`;

export const FETCH_BOOKING = gql`
  query FetchBookingTypeList($input: fetchBookInput) {
    FetchBookingTypeList(input: $input) {
      success
      data
      message
    }
  }
`;

export const FETCH_CONSOLE_BULK_BOOKING = gql`
  query Query($input: getBookingTypeInput) {
    getBookingTypeList(input: $input)
  }
`;

export const CONSOLE_VITRO_BULK_BOOKING = gql`
  mutation CreateBulkBooking($input: createBulkBookingInput) {
    createBulkBooking(input: $input)
  }
`;

export const FETCH_CONTRACTS = gql`
  query FetchForwarderContracts($input: fetchForwarderContracts) {
    fetchForwarderContracts(input: $input)
  }
`;

export const RFQ_BOOKING = gql`
  mutation CreateNewBooking($input: CreateNewBookingInput) {
    CreateNewBooking(input: $input)
  }
`;

export const CONSOLIDATED_BOOKING = gql`
  mutation ConsolidateBook($input: ConsolidateBookInput) {
    ConsolidateBook(input: $input)
  }
`;
export const UPDATE_SHIPMENT_WITHOUT_FORWARDER = gql`
  mutation BulkUpdatingBookingWithoutForwarder(
    $input: createBulkBookingWithoutForwarderInput
  ) {
    BulkUpdatingBookingWithoutForwarder(input: $input)
  }
`;
export const WAREHOUSE_LIST = gql`
  query Query {
    WarehouseList
  }
`;
export default SAVE_BOOKING;
